export default "__VITE_ASSET__BO$CT2yR__"